"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const PreviewerPageWrapper_1 = __importDefault(require("../PreviewerPageWrapper"));
const PreviewerLottieApphiveLoading_1 = __importDefault(require("../PreviewerLottieApphiveLoading"));
const PreviewerContext_1 = __importDefault(require("../../PreviewerContext"));
const style_1 = __importDefault(require("./style"));
const PreviewerPageSplash = ({ message, }) => {
    const { Render } = (0, react_1.useContext)(PreviewerContext_1.default);
    return (react_1.default.createElement(PreviewerPageWrapper_1.default, { background: "primary", centerItems: true },
        react_1.default.createElement(PreviewerLottieApphiveLoading_1.default, { style: style_1.default.lottieStyle }),
        react_1.default.createElement(Render.Text, { style: style_1.default.label }, message)));
};
exports.default = PreviewerPageSplash;
